<template>

    <div class="canvas::editor-website-FloatingPanel shadow-xl absolute" :style="{ width: width + 'px' }">

        <div class="rounded-t-lg text-white flex items-center top">

            <div class="mr-auto ml-5 title">{{ title }}</div>

            <button class="border-0 rounded-full text-white w-5 h-5 text-xs ml-3 mr-3 items-center close2" @click="close">
                <i class="fa fa-times"></i>
            </button>

        </div>

        <div class="bg-white rounded-b-lg py-1 content">

            <slot />

            <div class="m-5 actions" v-if="$slots['actions'] || $slots['actionsExtra'] || saveable">

                <slot name="actions" />

                <div v-if="!$slots['actions']">

                    <slot name="actionsExtra" />

                    <button v-if="saveable" class="btn btn-success" @click="save">
                        <i class="fas fa-check mr-2"></i>Opslaan
                    </button>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

    export default {

        inject: [
            '$pageComponent',
            'options',
        ],

        props: {
            title: {
                type: String,
                default: 'Instellingen',
            },
            width: {
            	type: Number,
                default: 400,
            },
            saveable: {
                type: Boolean,
                default: true,
            },
        },

        methods: {

            close()
            {
                this.$pageComponent().selection.setSelection(null);
            },

            save()
            {
                // Close after save.
                this.$pageComponent().state.$once('newHtml', html => this.close());

                // @ugly We asume AbstractPanel is above us.
                this.$parent.save();
            },

        },

    }

</script>

<style lang="scss" scoped>

    .canvas\:\:editor-website-FloatingPanel {
        left: 25px;
        top: 25px;

        .top {
            background: hsl(243deg 75% 59%);
            padding-bottom: 10px;
            padding-top: 10px;

            // Needed since a block css targets .title
            .title {
                font-size: 1rem;
            }

            .close2 {
                background: hsl(243deg 75% 59%);
                outline: none !important;
            }
        }

        .content {

            max-height: 80vh;
            overflow-y: scroll;

            &::v-deep {

                // TODO Right place?
                input::placeholder {
                    opacity: .5;
                }

            }

        }

    }

</style>
